export enum GACountryCode {
  France = 'FR',
  Germany = 'DE',
  GreatBritain = 'GB',
  Ireland = 'IE',
  Italy = 'IT',
  Spain = 'ES',
  UnitedStates = 'USA',
}
